import { useState } from "react"
import { BadgeInputDate } from "@ui/badge-input/date"
import InputLabel from "@ui/badge-input/input-label"
import { cn } from "@ui/utils"
import { format } from "date-fns"

interface DateSelectorProps {
  date: Date | undefined
  setDate: (date: Date | undefined) => void
  className?: string
  description?: string
  placeholder?: string
  showTimeToggle?: boolean
}

export default function DateSelector({
  date,
  setDate,
  className,
  description = "Due date",
  placeholder = "-",
  showTimeToggle = true,
}: DateSelectorProps) {
  const [showTime, setShowTime] = useState(false)

  function getDisplayedDate() {
    if (!date) return placeholder
    return format(date, showTime ? "MMM d, yyyy '@' h:mm a" : "MMMM d, yyyy")
  }

  return (
    <BadgeInputDate
      value={date ?? null}
      onValueChange={(value) => setDate(value ?? undefined)}
      showTime={showTimeToggle ? showTime : false}
      setShowTime={showTimeToggle ? setShowTime : undefined}
      includeTime={showTimeToggle}
      className={className}
    >
      <InputLabel
        label={getDisplayedDate()}
        description={description}
        className={cn(date ? "text-foreground" : "text-muted-foreground")}
      />
    </BadgeInputDate>
  )
}
